<span>
     <span *ngIf="!hideLink">
          <button
               (click) ="linkClick(params); $event.stopPropagation();"
               [id]="linkName"
               [name]="linkName"
               [title]="hoverText"
               [class]="linkClass"
          >
               {{ this.displayValue }}
     </button>
     </span>
     <span *ngIf="hideLink">
          {{ this.displayValue }}
     </span>

